import { ActionFunctionArgs } from "react-router-dom";

export async function lecturerCreateCourseAction({
  request,
  params,
}: ActionFunctionArgs) {}
